import {
  cvaFreeParkingPlacesBox,
  cvaFreeParkingPlacesItem,
  cvaFreeParkingPlacesList,
  cvaFreeParkingPlacesListTop,
  cvaFreeParkingPlacesPrice,
} from '~/widgets/FreeParking/FreeParkingPlacesList/FreeParkingPlacesListStyles';
import { cvaFreeParkingText } from '~/widgets/FreeParking/FreeParkingContent/FreeParkingStyles';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useCheckStage } from '~/widgets/FreeParking/model/useCheckStage';
import { priceFormatter } from '~/shared/utils/priceFormatter';
import { useGetParkingSpacesById } from '~/shared/hooks/useGetParkingSpacesById';
import { useStartDateStore } from '~/shared/store/startDateStore';
import { formatDateToString } from '~/shared/utils/dateFormatToString';
import { takeEndDate } from '~/shared/utils/takeEndDate';

interface Props {
  id: string | number;
  openPayment: (id: string | number) => void;
  isScrolling: boolean;
}

export const FreeParkingPlacesList = forwardRef<HTMLDivElement, Props>(
  ({ id, openPayment, isScrolling }, ref) => {
    const { startDate, activeTab } = useStartDateStore((state) => state.state);
    const endDate = takeEndDate(startDate, activeTab);
    const { currentStage, stageRefs } = useCheckStage();
    const { data: spaces, stages } = useGetParkingSpacesById(id, {
      period_start: formatDateToString(startDate),
      period_end: formatDateToString(endDate),
    });
    return (
      <div
        ref={ref}
        className={cvaFreeParkingPlacesList()}
        style={{ WebkitOverflowScrolling: 'touch' }}
        data-scroll={'y'}
        onTouchMove={(e) => e.stopPropagation()}>
        <div
          className={clsx(
            cvaFreeParkingPlacesListTop({ isScroll: isScrolling }),
            cvaFreeParkingText({ listText: false })
          )}>
          {currentStage} этаж
        </div>
        {stages.map((stage, i) => (
          <div key={i} className={'mb-1.2'}>
            {i !== 0 && (
              <p
                ref={(el) => (stageRefs.current[i] = el)}
                className={cvaFreeParkingText({ listText: true })}>
                {stage} этаж
              </p>
            )}
            <div className={cvaFreeParkingPlacesBox()}>
              {spaces &&
                spaces
                  .filter((place) => place.level === stage)
                  .map((place, j) => (
                    <div
                      key={j}
                      className={cvaFreeParkingPlacesItem()}
                      onClick={() => openPayment(place.id)}>
                      <h5 className={cvaFreeParkingPlacesPrice()}>
                        {priceFormatter(place.rates[0].price) ?? 0}
                      </h5>
                      <p className={cvaFreeParkingText()}>{place.number}</p>
                    </div>
                  ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
);
FreeParkingPlacesList.displayName = 'FreeParkingPlacesList';
